/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCouriersReport200ResponseValueTabsInner } from './GetCouriersReport200ResponseValueTabsInner';
import {
    GetCouriersReport200ResponseValueTabsInnerFromJSON,
    GetCouriersReport200ResponseValueTabsInnerFromJSONTyped,
    GetCouriersReport200ResponseValueTabsInnerToJSON,
    GetCouriersReport200ResponseValueTabsInnerToJSONTyped,
} from './GetCouriersReport200ResponseValueTabsInner';

/**
 * 
 * @export
 * @interface GetCouriersReport200ResponseValue
 */
export interface GetCouriersReport200ResponseValue {
    /**
     * 
     * @type {Date}
     * @memberof GetCouriersReport200ResponseValue
     */
    from: Date;
    /**
     * 
     * @type {Array<GetCouriersReport200ResponseValueTabsInner>}
     * @memberof GetCouriersReport200ResponseValue
     */
    tabs: Array<GetCouriersReport200ResponseValueTabsInner>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetCouriersReport200ResponseValue
     */
    payments: { [key: string]: number; };
}

/**
 * Check if a given object implements the GetCouriersReport200ResponseValue interface.
 */
export function instanceOfGetCouriersReport200ResponseValue(value: object): value is GetCouriersReport200ResponseValue {
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('tabs' in value) || value['tabs'] === undefined) return false;
    if (!('payments' in value) || value['payments'] === undefined) return false;
    return true;
}

export function GetCouriersReport200ResponseValueFromJSON(json: any): GetCouriersReport200ResponseValue {
    return GetCouriersReport200ResponseValueFromJSONTyped(json, false);
}

export function GetCouriersReport200ResponseValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCouriersReport200ResponseValue {
    if (json == null) {
        return json;
    }
    return {
        
        'from': (new Date(json['from'])),
        'tabs': ((json['tabs'] as Array<any>).map(GetCouriersReport200ResponseValueTabsInnerFromJSON)),
        'payments': json['payments'],
    };
}

export function GetCouriersReport200ResponseValueToJSON(json: any): GetCouriersReport200ResponseValue {
    return GetCouriersReport200ResponseValueToJSONTyped(json, false);
}

export function GetCouriersReport200ResponseValueToJSONTyped(value?: GetCouriersReport200ResponseValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': ((value['from']).toISOString()),
        'tabs': ((value['tabs'] as Array<any>).map(GetCouriersReport200ResponseValueTabsInnerToJSON)),
        'payments': value['payments'],
    };
}

